import PropTypes from 'prop-types'
import { Alert } from 'components/patterns'
import { Col } from 'components/patterns/Layout'
import { Header as PatternsHeader } from 'components/patterns/Typography'
import React from 'react'
import strings from 'utils/strings'
import {
  StepperLabelCol,
  StepperRow,
  StyledSteps,
} from './FeatureCollections.style'

const STEP_TITLES = [
  strings.select_collection,
  strings.add_to_vehicle,
  strings.resolve_conflicts,
  strings.review_features,
  strings.commit_changes,
]

const createSteps = ({ step }) =>
  STEP_TITLES.map((title, index) => ({
    title,
    disabled: step < index,
  }))

const FeatureCollectionsHeader = ({ serialNumber, step, exit }) => {
  const steps = createSteps({ step })

  const handleExit = () => {
    exit()
  }

  // WP-5: Dynamically show the current step name
  const currentStepTitle = STEP_TITLES[step] || STEP_TITLES[0]

  return (
    <>
      <Alert
        type="info"
        persistent
        closable={false}
        actionTrigger={{
          onClick: handleExit,
          text: strings.vehicle_banner_exit,
        }}
        message={`${strings.add_or_remove_features_to_vehicle} ${serialNumber}`}
      />
      <StepperRow alignItems="start">
        <StepperLabelCol justifyContent="center" alignItems="start" span={6}>
          <PatternsHeader type="h1">{currentStepTitle}</PatternsHeader>
        </StepperLabelCol>
        <Col offset={1} span={16}>
          <StyledSteps
            steps={steps}
            currentStep={step}
            labelPlacement="vertical"
          />
        </Col>
      </StepperRow>
    </>
  )
}

FeatureCollectionsHeader.propTypes = {
  serialNumber: PropTypes.string,
  step: PropTypes.number,
  exit: PropTypes.func,
}

export default FeatureCollectionsHeader
